import {
   ChangeDetectionStrategy,
   ChangeDetectorRef,
   Component,
   DoCheck,
   Input,
   OnDestroy,
   OnInit,
   ViewEncapsulation,
} from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { copyNameControlToShortNameAndDisplayName } from 'src/app/common-components/helpers/extension-form-helper';
import { ExtensionPrivileges } from '../../models/extension-privileges';
import { ExtensionTypeDetails } from '../../models/extension-type-details';
import { GetExtensionDetail_extension_extensionFax } from '../../queries/generated/GetExtensionDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-extension-fax-details',
    styleUrls: ['./extension-fax-details.component.scss'],
    templateUrl: './extension-fax-details.component.html',
    standalone: false
})
export class ExtensionFaxDetailsComponent extends ExtensionTypeDetails implements OnInit, DoCheck, OnDestroy {
   @Input() extensionFax: GetExtensionDetail_extension_extensionFax | null;

   @Input() accountId: number | null;

   @Input() extensionPrivileges: ExtensionPrivileges | null;

   form: UntypedFormGroup;

   constructor(
      private changeDetectorRef: ChangeDetectorRef,
      private controlContainer: ControlContainer,
      private parentForm: FormGroupDirective
   ) {
      super();
   }

   ngOnDestroy(): void {
      this.extensionFax = null;
   }

   ngOnInit(): void {
      this.form = <UntypedFormGroup>this.controlContainer.control;
      copyNameControlToShortNameAndDisplayName(this.parentForm.form, this.form);
   }

   ngDoCheck(): void {
      if (this.parentForm.form.invalid && (this.parentForm.submitted || this.form.touched)) {
         this.form.markAllAsTouched();
         this.changeDetectorRef.markForCheck();
      }
   }
}
